import { ITENS_DRIVER_FOLLOWZAP } from "@/lib/followzap-navigation";

export const ITENS_DRIVER = ITENS_DRIVER_FOLLOWZAP;

export type VisaoDriver = "pessoal" | "meu-driver" | "lixeira";

export function ehRotaDriver(pathname: string) {
  return pathname === "/drive" || ITENS_DRIVER.some((item) => item.href === pathname);
}

export function itemDriverAtivo(pathname: string, href: string) {
  return pathname === href || (pathname === "/drive" && href === "/drive/pessoal");
}
